{
  "s_light": "light",
  "s_dark": "dark",
  "nav_explore": "Explore Zürich",
  "nav_explore_desc": "Restaurants, hotels, things to do in Zürich and the surrounding area, and more.",
  "nav_home": "inzh.ch",
  "nav_home_desc": "Information portal for Zürich and the surrounding area",
  "nav_kantonsrat": "Cantonal Council",
  "nav_kantonsrat_desc": "Members, sessions, and committees of the Zurich Cantonal Council",
  "nav_about": "About",
  "nav_about_desc": "About inzh.ch, privacy policy and imprint",
  "l_expand": "Full view",
  "l_collapse": "Close full view",
  "l_back": "Back",
  "l_asceding": "Ascending",
  "l_descending": "Descending",
  "l_privacy": "Privacy",
  "l_privacy_txt": "inzh.ch stores a cookie to save the theme preference. The sources of the interactive map and the images additionally try to set third-party cookies.",
  "l_impressum": "Imprint",
  "l_page_not_found": "Page not found / 404",
  "nav_news": "News and Updates",
  "nav_news_desc": "News and general information from Zurich and beyond"
}